import baseRequest from 'queries/baseRequest';
import endpoints from 'consts/endpoints';

const getAccountsByOrderId = (orderId: string) => baseRequest({ path: endpoints.getAccountsByOrderIdUrl(orderId) });

export default getAccountsByOrderId;
